export default __webpack_public_path__ + "static/media/fri-gray.43bdfa89.png";